<script>
import { Form as VeeForm, Field, ErrorMessage } from "vee-validate"
import * as yup from "yup"
import { ref } from 'vue'
import VueDatepicker from '@vuepic/vue-datepicker'
import moment from 'moment'
import Icon from "@/components/Icon/Icon.vue"
import Popper from "vue3-popper"
import personService from "@/services/person.service"
import userService from "@/services/user.service"
import RightsEnum from "@/enum/rights.enum"
import PersonPanel from '@/components/person/PersonPanel.vue'
import AutoComplete from 'primevue/autocomplete'
import Dialog from 'primevue/dialog'
import AvailabilityButton from '@/components/availability/AvailabilityButton.vue'
import AppointmentFreeModal from '@/components/appointment/AppointmentFreeModal.vue'

export default {
    name: "AppointmentForm",
    components: {
        VeeForm,
        Field,
        ErrorMessage,
        VueDatepicker,
        Icon,
        Popper,
        personService,
        PersonPanel,
        AutoComplete,
        Dialog,
        AvailabilityButton,
        AppointmentFreeModal,
    },
    data() {
      return {
          loading: false,
          message: "",
          isReset: 1,
          datecheck: null,
          heurecheck: null,
          id: null,
          duration: 60,
          description: '',
          action: 'rien',
          reason_id: null,
          place_id: null,
          person_uuid: null,
          places: [],
          reasons: [],
          persons: [],
          person: {},
          selectedPersonUuid: null,
          personName: '',
          selectedReason: 0,
          selectedPlace: 0,
          showModal: false,
          brand: {},
          visible: ref(false),
          showFreeModal: false,
          currentGroupUuid: null,
      };
    },
    computed: {
      currentAccountName() {
        return this.$store.state.account.name
      },
      currentAccountSid() {
        return this.$store.state.account.sid
      },
    },
    props: {
        externData: {
            type: Object,
            required: true,
        },
    },
    watch: {
        externData: function(newVal) {
            this.isReset = 1

            this.id = newVal?.id;

            //this.date = ref(moment(newVal?.date));
            if(newVal?.date == null) {
                this.date = null
            }
            else {
                this.date = moment(newVal?.date).format('YYYY-MM-DD');
            }
            this.datecheck = this.date

            if(newVal?.time == null) {
                this.heure = null
                this.heurecheck = null
            } else {
                this.heure = { 
                    hours: newVal?.time.slice(0, 2),
                    minutes: newVal?.time.slice(3, 5)
                };
                this.heurecheck = this.heure.hours + ':' + this.heure.minutes
            }

            this.duration = newVal?.duration
            this.description = newVal?.description
            this.selectedPersonUuid = newVal?.person_uuid
            this.personName = newVal?.person_name

            this.reason_id = newVal?.reason_id
            if(!this.reason_id) {
              this.selectedReason = this.reasons[0].id
              //this.duration = this.reasons[0].duration
              if(this.reasons[0]?.duration) {
                this.duration = this.reasons[0]?.duration
              } else {
                this.duration = this.$store.state.account.setting.duration
              }
            } else {
              this.selectedReason = this.reason_id
            }
            
            this.place_id = newVal?.place_id;
            if(!this.place_id) {
                this.selectedPlace = this.places[0].id
            } else {
                this.selectedPlace = this.place_id
            }

            if(this.selectedPersonUuid != null ) {
                const persons = this.$store.state.account.persons;
                //const found = persons.find(element => element.id == this.selectedPersonUuid);
                if(persons[this.selectedPersonUuid])
                {
                  this.person = persons[this.selectedPersonUuid]
                  this.personName = this.person?.name
                }
            } else {
              this.cancel()
            }

            this.$store.dispatch('account/addPersonSelected', this.person)

            this.currentGroupUuid = this.$store.state.account.currentGroupUuid
        }
    },
    mounted: function() {
        this.reasons = this.$store.state.account.reasons
        this.places = this.$store.state.account.places

        if(this.reasons.length) {
          this.selectedReason = this.reasons[0]?.id
          if(this.reasons[0]?.duration) {
            this.duration = this.reasons[0]?.duration
          }
        }

        if(this.places.length)
        {
          this.selectedPlace = this.places[0]?.id
        }

        this.duration = this.$store.state.account.setting.duration

        this.currentGroupUuid = this.$store.state.account.currentGroupUuid

        this.datecheck = this.date
        this.heurecheck = this.heure.hours + ':' + this.heure.minutes
    },
    setup() {
        const date = ref(moment())
        
        const heure = ref({ 
            hours: new Date().getHours(),
            minutes: new Date().getMinutes()
        });

        const textInputOptions = ref({
            format: 'dd/MM/yyyy'
        })

        const schema = yup.object().shape({
          isReset: yup.number(),
          datecheck: yup.string().nullable().when('isReset', {
            is: 0,
            then: yup.string()
              .typeError("La date doit être remplie")
              .required("La date est obligatoire"),
          }),
          heurecheck: yup.string().nullable().when('isReset', {
            is: 0,
            then: yup.string()
              .typeError("L'heure doit être remplie")
              .required("L'heure est obligatoire"),
          }),
          duration: yup.number().when('isReset', {
            is: 0,
            then: yup.number()
              .typeError('La durée doit être un nombre')
              .required("La durée est obligatoire")
              .positive("La durée doit être positive")
              .integer("La durée doit être un nombre"),
          }),
          reason_id: yup.number().when('isReset', {
            is: 0,
            then: yup.number()
              .typeError("Le motif doit être rempli")
              .required("Le motif est obligatoire")
              .min(1, "Le motif doit être renseigné"),
          }),
          place_id: yup.number().when('isReset', {
            is: 0,
            then: yup.number()
              .typeError("Le lieu doit être rempli")
              .required("Le lieu est obligatoire")
              .min(1, "Le lieu doit être renseigné"),
          }),
        });

        //const activationValidation = ref(schema)
        
        return {
            date,
            heure,
            textInputOptions,
            schema,
        }
    },
    methods: {
        cancel() {
          this.selectedPersonUuid = null
          this.person = {
            uuid: null,
            name: null,
            email: null,
            phone: null,
            note: null,
          }
          this.personName = null

          this.$store.dispatch('account/addPersonSelected', this.person)
        },
        itemSelect($event) {
          this.selectedPersonUuid = $event.value.uuid
          this.person = {
            uuid: $event.value.uuid,
            name: this.personName.name,
            email: this.personName.email,
            phone: this.personName.phone,
            note: this.personName.note,
          }
          this.$store.dispatch('account/addPersonSelected', this.person)
        },
        changeClient() {
          this.selectedPersonUuid = null
          this.person = {
            uuid: null,
            name: this.personName,
            email: '',
            phone: '',
            note: '',
          }
          this.$store.dispatch('account/addPersonSelected', this.person)
        },
        changePerson() {
          if(!this.selectedPersonUuid)
          {
            this.personName = ''
          }
          this.$store.dispatch('account/addPersonSelected', this.person)
        },
        search() {
          personService.searchByAccount({
              account: this.$store.state.account.uuid,
              name: this.person.name,
          })
          .then(data => {
              this.persons = []

              if(data['persons'].result.length)
              {
                  this.persons = [];

                  data['persons'].result.forEach((el) => {
                    this.persons.push({
                      uuid: el.uuid,
                      name: el.name,
                      email: el.email,
                      phone: el.phone,
                      note: el.note,
                    })
                  })
              }
          });
        },
        openModal() {
            this.showModal = true
        },
        closeCallback(person) {
          this.showModal = false
          this.selectedPersonUuid = person.uuid
          this.personName = person.name
          this.person = person

          this.$store.dispatch('account/addPersonSelected', this.person)
        },
        handleDate(modelData) {
          const date = moment(modelData)
          if(date.isValid()) {
            this.datecheck = date.format('DD/MM/YYYY');
          }
          else {
            this.datecheck = '';
          }
        },
        handleHeure(modelHeure) {
          const heure = moment(modelHeure)
          if(heure.isValid()) {
            this.heurecheck = heure.format('HH:mm');
          }
          else {
            this.heurecheck = '';
          }
        },
        handleCreate(appointment) {
            appointment.date = this.date
            appointment.heure = this.heure

            appointment.person_name = this.personName;

            if(this.action == "creer") {
                this.$emit('add-appointment', appointment);
            }
            else if(this.action == "modifier") {
                this.$emit('update-appointment', appointment);
            }
            else if(this.action == "supprimer") {
                this.$emit('remove-appointment', appointment);
            }
            else if(this.action == "reset") {
                this.$emit('reset-appointment')
            }

            this.action = 'fini'
        },
        creerAction() {
            this.isReset = 0
            this.action = 'creer'
        },
        modifierAction() {
            this.isReset = 0
            this.action = 'modifier'
        },
        supprimerAction() {
          this.isReset = 0
            this.action = 'supprimer'
        },
        resetAction() {
            this.action = 'reset'
        },
        setNewData(duration) {
            this.duration = duration
        },
        openFreeModal() {
            this.showFreeModal = true
        },
        closeFreeCallback() {
            this.showFreeModal = false
        },
        actionOnAppointment(availability) {
            //this.appointmentData = item;
            //this.selectedAppointment = true

            this.id = null

            this.date = availability.date
            this.datecheck = this.date

            this.heure = {
                hours: availability.time.slice(0, 2),
                minutes: availability.time.slice(3, 5)
            };
            this.heurecheck = this.heure.hours + ':' + this.heure.minutes

            this.duration = availability.duration
        },
        changeReasons(event) {
          const found = this.reasons.find(element => element.id == event.target.value)

          if(found.duration !== null) {
            this.duration = found.duration
          } else {
            this.duration = this.$store.state.account.setting.duration
          }
        },
        hasPermissionWrite() {
          return userService.hasPermission(RightsEnum.Write)
        },
        hasPermissionPublic() {
          return userService.hasPermission(RightsEnum.Public)
        },
        hasPermissionPerson() {
          return userService.hasPermission(RightsEnum.Person)
        }
    },
};

</script>

<template>
  <div>
    <PersonPanel
      :externShowModal="showModal"
      :externName="person"
      @close="closeCallback"
    />

    <AppointmentFreeModal
        :externShowFreeModal="showFreeModal"
        @close="closeFreeCallback"
    />

    <div v-show="hasPermissionWrite()" class="m-3 p-2">
      <VeeForm v-slot="{ handleSubmit }" @submit="handleCreate" :validation-schema="schema">
      <div class="flex justify-between mt-14">
        <div class="form-group flex justify-center gap-2 w-11/12 m-auto pt-2 pb-2">
          <button class="btn" value="Reset" @click="resetAction">
            <span>Nouveau</span>
          </button>
        </div>

        <div v-show="hasPermissionPublic()" class="form-group flex justify-center gap-2 w-11/12 m-auto pt-2 pb-2" @click="openFreeModal">
            <button class="btn">
                <span>Rdv libre</span>
            </button>
        </div>
      </div>

      <div class="my-10">
        <div class="form-group">
          <Field name="isReset" v-model="isReset" class="form-control" type="hidden" value="1" />
          <Field name="id" v-model="id" class="form-control" type="hidden" />
        </div>

        <div class="ml-4 my-4 text-orange-300 flex
    before:content-[''] before:flex-none before:w-4 before:border-b before:border-orange-300 before:my-auto
    after:content-[''] after:flex-1 after:border-b after:border-orange-300 after:my-auto">
          <span class="px-2 text-xs text-orange-300">Date et horaire</span>
        </div>

        <div>
        <AvailabilityButton
            :externDuration="duration"
            @action-on-form="actionOnAppointment"
        />
        </div>

        <div class="form-group flex justify-between">
          <!--label for="date">Date</label-->
          <VueDatepicker
            v-model="date"
            :clearable="true"
            :enableTimePicker="false"
            locale="fr"
            cancelText="Annuler"
            selectText="Valider"
            format="dd/MM/yyyy"
            :typeable="true"
            text-input
            :text-input-options="textInputOptions"
            auto-apply
            :style="{'width': '150px'}"
            :model-value="date"
            @update:model-value="handleDate"
          />
          <Field name="datecheck" v-model="datecheck" type="hidden" :validateOnBlur="false" :validateOnChange="false" :validateOnInput="false" />

          <!--label for="heure">Heure</label-->
          <VueDatepicker
            v-model="heure"
            :clearable="true"
            time-picker
            locale="fr"
            :typeable="true"
            auto-apply
            :style="{'width': '110px'}"
            position="left"
            :teleport="true"
            :model-value="heure"
            @update:model-value="handleHeure"
          >
            <template #input-icon>
              <icon name="clock" class="dp__icon dp__input_icon dp__input_icons" :size="32" color="black" />
            </template>
          </VueDatepicker>
          <Field name="heurecheck" v-model="heurecheck" type="hidden" :validateOnBlur="false" :validateOnChange="false" :validateOnInput="false" />
        </div>

        <div class="form-group flex flex-col">
          <ErrorMessage name="datecheck" v-slot="{ message }">
            <div class="border border-red-400 text-red-700 px-4 py-0 mt-2 rounded relative" role="alert">
              {{ message }}
            </div>
          </ErrorMessage>
          <ErrorMessage name="heurecheck" v-slot="{ message }">
            <div class="border border-red-400 text-red-700 px-4 py-0 mt-2 rounded relative" role="alert">
              {{ message }}
            </div>
          </ErrorMessage>
        </div>
      </div>
      <div class="my-10">
        <div class="ml-4 my-2 text-orange-300 flex
    before:content-[''] before:flex-none before:w-4 before:border-b before:border-orange-300 before:my-auto
    after:content-[''] after:flex-1 after:border-b after:border-orange-300 after:my-auto">
          <span class="px-2 text-xs text-orange-300">Informations</span>
        </div>
        <div v-show="reasons.length > 1" class="form-group flex pt-2">
          <!--label for="motif">Motif</label-->
          <Field
            name="reason_id"
            @change="changeReasons"
            as="select"
            class="form-control w-full p-1 bg-white border border-orange-300"
            v-model="selectedReason"
          >
            <!--option v-if="reasons.length > 1" value="0">Sélectionner le motif</option-->
            <option v-for="reason in reasons" :key="reason.id" :value="reason.id">{{ reason.name }}</option>
          </Field>

          <div class="w-4 m-1">
            <router-link :to="{name: 'setting', params: {account: currentAccountSid, component: 'ReasonSetting'}}">
              <icon name="setting" :size="32" color="black" />
            </router-link>
          </div>
          <Popper :style="{'margin': 0, 'border': 'none'}">
            <div class="hover:cursor-pointer w-4 m-1 p-0"><icon name="file-text" :size="32" color="black" /></div>
            <template #content>
              <div class="border border-black bg-white">
                <table class="min-w-full text-left text-sm font-light">
                  <thead class="border-b font-medium dark:border-neutral-500">
                    <tr>
                      <th scope="col" class="px-6 py-4">Nom du motif</th>
                      <th scope="col" class="px-6 py-4">Couleur</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      :ref="reason.id"
                      class="border-b dark:border-neutral-500"
                      v-for="reason in reasons"
                      :key="reason.id"
                    >
                      <td class="whitespace-nowrap px-6 py-0">{{ reason.name }}</td>
                      <td class="whitespace-nowrap px-6 py-0 text-center">
                        <span class="w-4 h-4 inline-block border border-black" :style="{'background-color': reason.color}"></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>
          </Popper>
        </div>
          <ErrorMessage name="reason_id" v-slot="{ message }">
          <div class="form-group flex pb-4">
            <div class="border border-red-400 text-red-700 px-4 py-0 mt-2 rounded relative w-full" role="alert">
              {{ message }}
            </div>
          </div>
          </ErrorMessage>

        <div class="form-group flex justify-between pt-2 pb-2 gap-4">
          <!--label for="duration">Durée</label-->
          <div class="flex justify-center">
            <Field
              name="duration"
              v-model="duration"
              class="form-control form-input w-18"
              type="number"
              :validateOnBlur="false"
              :validateOnChange="false"
              :validateOnInput="false"
            />
            <span class="m-auto ml-1">min</span>
          </div>
          <div class="flex justify-between gap-2 p-1">
            <div class="btn-duration" @click="setNewData(30)">30</div>
            <div class="btn-duration" @click="setNewData(45)">45</div>
            <div class="btn-duration" @click="setNewData(60)">60</div>
            <div class="btn-duration" @click="setNewData(90)">90</div>
          </div>
        </div>
        <div class="form-group flex flex-col">
          <ErrorMessage name="duration" v-slot="{ message }">
            <div class="border border-red-400 text-red-700 px-4 py-0 mt-2 rounded relative" role="alert">
              {{ message }}
            </div>
          </ErrorMessage>
        </div>

        <div v-show="places.length > 1" class="form-group flex mt-2">
          <!--label for="lieu">Lieu</label-->
          <Field name="place_id" as="select" class="form-control w-full p-1 bg-white border border-orange-300" v-model="selectedPlace">
            <!--option v-if="places.length > 1" value="0">Sélectionner le lieu</option-->
            <option v-for="place in places" :key="place.id" :value="place.id">{{ place.name }}</option>
          </Field>
          <div class="w-4 m-1 p-0">
            <router-link :to="{name: 'setting', params: {account: currentAccountSid, component: 'PlaceSetting'}}">
              <icon name="setting" :size="32" color="black" />
            </router-link>
          </div>
          <Popper :style="{'margin': 0, 'border': 'none'}">
            <div class="hover:cursor-pointer w-4 m-1"><icon name="file-text" :size="32" color="black" /></div>
            <template #content>
              <div class="border border-black bg-white">
                <table class="min-w-full text-left text-sm font-light">
                  <thead class="border-b font-medium dark:border-neutral-500">
                    <tr>
                      <th scope="col" class="px-6 py-4">Nom du lieu</th>
                      <th scope="col" class="px-6 py-4">Couleur</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      :ref="place.id"
                      class="border-b dark:border-neutral-500"
                      v-for="place in places"
                      :key="place.id"
                    >
                      <td class="whitespace-nowrap px-6 py-0">{{ place.name }}</td>
                      <td class="whitespace-nowrap px-6 py-0 text-center">
                        <span class="w-4 h-4 inline-block border border-black" :style="{'background-color': place.color}"></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>
          </Popper>
        </div>
          <ErrorMessage name="place_id" v-slot="{ message }">
          <div class="form-group flex pt-2">
            <div class="border border-red-400 text-red-700 px-4 py-0 mt-2 rounded relative w-full" role="alert">
              {{ message }}
            </div>
          </div>
          </ErrorMessage>

        <div class="form-group flex justify-between pt-2 pb-2 gap-4">
          <Field
            name="person_uuid"
            v-model="selectedPersonUuid"
            @change="changePerson"
            type="hidden"
            class="w-8"
            value="0"
          />

          <AutoComplete
            name="person_name"
            v-model="personName"
            class="form-control form-input mb-1"
            placeholder="Choisir le client..."
            :suggestions="persons"
            @complete="search"
            @item-select="itemSelect"
            @change="changeClient"
            optionLabel="name"
          >
            <template #optiongroup="slotProps">
                <div class="flex align-items-center country-item">
                  <div id="{{ slotProps.option.id }}">{{ slotProps.option.name }}</div>
                </div>
            </template>
          </AutoComplete>

          <div class="flex justify-center">
            <div v-show="hasPermissionPerson()" v-if="personName && !selectedPersonUuid" class="m-auto hover:cursor-pointer w-6 p-0" @click="openModal">
                <Icon name="add_box" :size="25" class="text-orange-300" />
            </div>
            <div v-if="selectedPersonUuid" class="m-auto hover:cursor-pointer w-6 p-0" @click="openModal">
                <Icon name="pencil" :size="25" class="text-orange-300" />
            </div>
            <div @click="cancel()" class="m-auto hover:cursor-pointer">
              <icon name="remove" :size="16" class="w-6 h-6 text-orange-300" />
            </div>
            <ErrorMessage name="person_uuid" class="error-feedback" />
          </div>
        </div>

        <div class="form-group">
          <!--label for="description">Note</label-->
          <Field v-slot="{ field, errors }" v-model="description" name="description" class="form-control w-full">
            <textarea v-bind="field" name="description" class="p-1 w-full border border-orange-500 h-16" />
            <div v-if="errors[0]">{{errors[0]}}</div>
          </Field>
          <ErrorMessage name="description" class="error-feedback" />
        </div>

        <div v-show="id == null" class="form-group flex justify-center gap-2 w-11/12 mx-auto my-10 pt-2 pb-2">
          <button class="btn" :disabled="loading" value="creer" @click="creerAction">
            <span v-show="loading" class="spinner-border spinner-border-sm"></span>
            <span>Créer</span>
          </button>
        </div>

        <div v-show="id != null" class="form-group flex justify-center gap-2 w-11/12 mx-auto my-10 pt-2 pb-2">
          <button type="submit" class="btn" value="copier" @click="creerAction">
            <span>Copier</span>
          </button>

          <button type="submit" class="btn" value="modifier" @click="modifierAction">
            <span>Modifier</span>
          </button>

          <button type="submit" class="btn" value="supprimer" @click="supprimerAction">
            <span>Supprimer</span>
          </button>
        </div>

        <div class="form-group">
          <div v-if="message" class="alert alert-danger" role="alert">
            {{ message }}
          </div>
        </div>
      </div>
      </VeeForm>
    </div>
  </div>
</template>

<style scoped>

  .btn-duration {
    @apply hover:cursor-pointer bg-white hover:bg-orange-500 text-orange-300 font-semibold hover:text-white py-1 px-1
      border border-orange-500 hover:border-transparent rounded
  }

</style>
